import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchTransactionDetailsById } from '../../services/api';
import Loading from '../../components/Loading/Loading';
import "./Reportview.scss";

const Reportview = () => {
  const { transactionId } = useParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const getTransaction = async () => {
      setLoading(true);
      try {
        const response = await fetchTransactionDetailsById(transactionId);
        setTransaction(response.data);
        console.log(response.data);
      } catch (error) {
        setError('Error fetching transaction data');
      } finally {
        setLoading(false);
      }
    };

    if (transactionId) {
      getTransaction();
    }
  }, [transactionId]);

  const handleBack = () => {
    history.push('/report');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Render the content conditionally based on loading, error, and transaction state
  return (
    <section>
      {loading && <Loading />}
      {error && <p>{error}</p>}
      {!loading && transaction && (
        <div className="details-container card">
          <div className="container-head p-15">
            <h2>Inspective Details</h2>
            <div className="btns">
              <span className="add-btn" onClick={handleBack}>
                <p>Back</p>
              </span>
            </div>
          </div>
          <form>
            <div className="details-row d-flex">
              <div className="inputs-details">
                <label>Name:</label>
                <input value={transaction.userName || ''} readOnly />
              </div>
              <div className="inputs-details">
                <label>Comment:</label>
                <input value={transaction.comment || ''} readOnly />
              </div>
            </div>
            <div className="details-row d-flex">
              <div className="inputs-details">
                <label>House Status:</label>
                <input value={transaction.houseStatus || ''} readOnly />
              </div>
              <div className="inputs-details">
                <label>Reported Date:</label>
                <input value={formatDate(transaction.reportedDate) || ''} readOnly />
              </div>
            </div>
          </form>

          {/* Image Card Section */}
          <div className="transaction-images">
            {(!transaction || !transaction.images || transaction.images.length === 0) ? null : (
              transaction.images.length === 1 ? (
                <img
                  src={`https://drdatvrhousing.newtoncloudhost.com/${transaction.images[0].imageUrl}`}
                  alt="transaction-img"
                  className="single-image"
                />
              ) : (
                <div className="image-gallery">
                  {transaction.images.map((image, index) => (
                    <img
                      key={index}
                      src={`https://drdatvrhousing.newtoncloudhost.com/${image.imageUrl}`}
                      alt={`transaction-img-${index}`}
                      className="gallery-image"
                    />
                  ))}
                </div>
              )
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Reportview;
